import React from 'react';
// import { connect } from 'react-redux'
import SliderView from './SliderView';
import { onDropComponent } from './DropComponentCommonFunctions';
import { DnD_element_type_category, DnD_element_type_menu } from '../common/ConstantValues';

const SliderViewContainer = (props) => {
  // custom props
  const { 
    message_index, 
    row_index, 
    components, 
    attr, 
    type, 
    // editingIndexes, 
    messageActions, 
    currentEditSlidePage, 
    setIndex,
    isDragging,
  } = props
  // props
  const { 
    // editing_message_index, 
    // editing_row_index, 
    // slide_page_index, 
    id 
  } = props
  // functions
  // const { currentEditSlidePage, setIndexForSlidePage, updateComponentIndexPos, deleteComponent, setCurrentEditSlidePage, addComponent, setIsDragging, setMsgChanges } = props
  
  // indexes
  // const {
  //   editing_message_index,
  //   editing_row_index,
  //   editing_slide_page_index,
  // } = editingIndexes
  const {
    editing_message_index,
    editing_row_index,
    editing_slide_page_index,
  } = props

  // Actions for message data
  const { 
    addComponent, 
    updateComponentIndexPos, 
    setIndexForSlidePage, 
    updateRow, 
    setMsgChanges, 
    deleteComponent,
    copyComponent, 
    setIsDragging,
    setCurrentEditSlidePage,
    updateSlidePageToMessage,
  } = messageActions
  /**
   * 슬라이드 페이지 디테일 뷰 quit
   */
  const quitSlidePageDetail = () => {
    setCurrentEditSlidePage(null)
    setIndex(null)
  }

  /**
   * 슬라이드 페이지 디테일 뷰 complete
   */
  const completeSlidePageDetail = () => {
    updateSlidePageToMessage({
      message_index: editing_message_index,
      row_index: editing_row_index,
      slide_page_index: editing_slide_page_index+1, // Syncing index
    })
    setCurrentEditSlidePage(null)
    setIndex(null)
    setMsgChanges(true)
  }

  /**
   * 슬라이드 페이지 사이의 dropArea onDrop handling
   */
  const dropSideArea = (e) => {
    const { message_index_target, row_index_target, component_index_target } = e
    
    const { cat_type, prefix_type, type } = e
    // cat_type에 따른 로직 분기
    if (!cat_type) {
      console.error('No cat_type => ', cat_type)
      return
    }
    switch(cat_type) {
      case DnD_element_type_category.REN_ELEM: 
        onDropComponent(updateComponentIndexPos, e, message_index_target, row_index_target, component_index_target)
        setMsgChanges(true)
        break;
      case DnD_element_type_category.MENU:
        addComponent({
          message_index: message_index_target,
          row_index: row_index_target,
          component_index: component_index_target,
          type: type,
          prefix_type: prefix_type,})
          setMsgChanges(true)
        // onDropComponent(addComponent, e, message_index_target, row_index_target, component_index_target)
      break;
      default:
        console.error("No detect cat_type => '" + cat_type + "'")
    }
  }

  /**
   * 슬라이드 페이지 Delete
   */
  const deleteSlidePage = () => {
    const { editing_message_index, editing_row_index, editing_slide_page_index } = props
    const args = {
      messageIndex: editing_message_index,
      rowIndex: editing_row_index,
      componentIndex: editing_slide_page_index+1,
    }
    onDropComponent(deleteComponent, args, null, null, null)
    quitSlidePageDetail()
    setMsgChanges(true)
  }

  /**
   * 슬라이드 페이지 마지막 추가 버튼 onClick 기능
   */
  const onClickLastBtn = () => {
    addComponent({
      message_index: message_index,
      row_index: row_index,
      component_index: components.length,
      type: '_' + type.type,
      prefix_type: 'NORMAL',
    })
    setMsgChanges(true)
  }

  /**
   * 상세 뷰의 Initialize drop area의 drop 이벤트
   * @param {Object} e 
   */
  const onDropInitArea = (e) => {
    const { type, prefix_type, cat_type } = e
    addComponent({
      message_index: 0,
      row_index: 0,
      // component_index: 0,
      type: type,
      prefix_type: prefix_type,
      slidePageIndex: editing_slide_page_index,
      rowIndexDetail: 0,
    })
  }

  /**
   * onDrag start/end
   * @param {Object} e 
   */
  const onDragStart = () => {
    setIsDragging({
      dragging: true,
      type: null
    })
  }
  const onDragEnd = () => {
    setIsDragging({
      dragging: false,
      type: null
    })
  }

  return (
    <SliderView {...props}
      key={id}
      setIndex={setIndex}
      currentEditSlidePage={currentEditSlidePage}
      quitSlidePageDetail={quitSlidePageDetail}
      completeSlidePageDetail={completeSlidePageDetail}
      // editingIndexes={editingIndexes}
      editing_message_index= {props.editing_message_index}
      editing_row_index= {props.editing_row_index}
      editing_slide_page_index= {props.editing_slide_page_index}
      dropSideArea={dropSideArea}
      deleteSlidePage={deleteSlidePage}
      onClickLastBtn={onClickLastBtn}
      onDropInitArea={onDropInitArea}
      // setHScrollValue={setHScrollValue}
      // horizontalScrollValue={horizontalScrollValue}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      messageActions={messageActions} 
    />
  )
}

const mapStateToProps = (state) => ({
  // Current edit slide page
  // currentEditSlidePage: state.MessageModule.currentEditSlidePage,
  /**
   * Container props에 message_index, row_index와 네이밍이 겹쳐 detail로 빼주었음
   */
  // editing_message_index: state.SlidePageState.message_index,
  // editing_row_index: state.SlidePageState.row_index,
  // slide_page_index: state.SlidePageState.slide_page_index,
  // horizontalScrollValue: state.SlidePageState.horizontalScrollValue,
})

const mapDispatchToProps = (dispatch) => ({
  // Set current edit slide page action
  // setSlidePage: (editSlidePage) => {dispatch(setCurrentEditSlidePage(editSlidePage))},
  // setIndexForSlidePage : (arg) => {dispatch(setIndex(arg))},
  // updateSlidePageToMessage : (arg) => {dispatch(updateSlidePageToMessage(arg))},
  // updateComponentIndexPos: (arg) => {dispatch(updateComponentIndexPos(arg))},
  // deleteComponent: (arg) => {dispatch(deleteComponent(arg))},
  // addComponent: (arg) => {dispatch(addComponent(arg))},
  // setIsDragging: (arg) => {dispatch(setIsDragging(arg))},
  // setMsgChanges: (value) => {dispatch(setMsgChanges(value))},
  // setHScrollValue: (arg) => {dispatch(setHScrollValue(arg))},
})

export default SliderViewContainer